import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { StateService } from './state.service';
import { User } from '../models/user.model';
import { LoggerService } from '../services/common/logger.service';

export interface UserSlice {
  profile: User | null;
  loading: boolean;
}

const initialUserState: UserSlice = {
  profile: null,
  loading: true,
};

@Injectable({ providedIn: 'root' })
export class UserStateService extends StateService<UserSlice> {
  constructor(@Inject(PLATFORM_ID) platformId: Object, logger: LoggerService) {
    super(initialUserState, platformId, logger);
  }

  selectProfile(): Observable<User | null> {
    return this.select(s => s.profile);
  }

  selectLoading(): Observable<boolean> {
    return this.select(s => s.loading);
  }

  setProfile(profile: User | null): void {
    this.setState({ profile, loading: false });
  }

  setLoading(loading: boolean): void {
    this.setState({ loading });
  }
}
